import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import axios from 'axios';
import { useSettings } from '../context/settingContext';
import Loader from '../component/Loader';

gsap.registerPlugin(ScrollTrigger);

function PrivacyPolicy() {
  const sectionsRef = useRef([]);

  useEffect(() => {
    sectionsRef.current.forEach((section) => {
      gsap.fromTo(
        section,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: section,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      );
    });
  }, []);

  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  const [pageContent, setPageContent] = useState(null);
  const { renderHTML } = useSettings();
  const getPageContent = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-content/PrivacyPolicyPage`);
      setPageContent(res.data.data[0])
    } catch (err) {
      console.log('Fetching Page Content', err)
    }
  }

  useEffect(() => {
    getPageContent();
  }, []);

  if (pageContent === null) {
    return <Loader />
  }

  return (
    <div className="bg-gray-50 min-h-screen py-12 px-6">
      <section className="privacy-policy">
        <div className="container mx-auto my-10 p-10">
          <h1
            className="text-4xl  text-center font-bold mb-8 font-syne"
            ref={addToRefs}
          >
            {pageContent.title}
          </h1>
          {renderHTML(pageContent.details)}
        </div>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
